import React, { PureComponent } from 'react';

import classNames from 'classnames';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';
// import compareAsc from 'date-fns/compareAsc';
import isEqual from 'date-fns/isEqual';
import isAfter from 'date-fns/isAfter';
import { DateUtils, Modifier } from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import DatePickerIcon from '@geobank/assets/src/icons/DatePickerIcon';

import 'react-day-picker/lib/style.css';
import './DateInput.css';

// TODO - все стили оформить в astroturf
const styles = require('./DateInput-styles.module.scss');

interface DateInputProps {
  className?: string;
  locale: string;
  value?: Date;
  onChange: (value?: Date) => void;
  format?: string;
  placeholder?: string;
  pullRight?: boolean;
  disabledDays?: Modifier | Modifier[];
  validateFunction?: (value?: Date) => boolean;
  errorMessage?: string;
  isError?: (value: boolean) => void;
  width?: string;
  allowEmpty?: boolean;
}

function parseDate(str: string, format: string) {
  // const parsed = dateFnsParse(str, format, new Date(), { locale });
  const parsed = dateFnsParse(str, format, new Date());
  if (DateUtils.isDate(parsed) && isAfter(parsed, new Date(1970, 0, 1))) {
    return parsed;
  }
  return undefined;
}
function formatDate(date: Date, format: string) {
  return dateFnsFormat(date, format);
}

const WEEKDAYS_SHORT_RU = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
const WEEKDAYS_SHORT_EN = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

const MONTHS_RU = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

const MONTHS_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const WEEKDAYS_LONG_RU = [
  'Воскресенье',
  'Понедельник',
  'Вторник',
  'Среда',
  'Четверг',
  'Пятница',
  'Суббота',
];

const WEEKDAYS_LONG_EN = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const FIRST_DAY_OF_WEEK = 1;

const LABELS = { nextMonth: 'следующий месяц', previousMonth: 'предыдущий месяц' };

const DateInput: React.FC<DateInputProps> = props => {
  const {
    allowEmpty,
    className,
    disabledDays,
    errorMessage,
    format,
    locale,
    placeholder,
    pullRight,
    value,
    width,
    isError,
    onChange,
    validateFunction,
  } = props;
  const [dateInputValue, setDateInputValue] = React.useState<Date>();
  const [isInvalid, setIsInvalid] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (allowEmpty || value !== undefined) {
      changeHandler(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeHandler = React.useCallback(
    (selectedDay?: Date, modifiers?: any, dayPickerInput?: DayPickerInput) => {
      const input: any = dayPickerInput?.getInput();
      if (validateFunction && !validateFunction(selectedDay)) {
        if (allowEmpty && (input?.value === undefined || input?.value.trim() === '')) {
          onChange(selectedDay);
          setDateInputValue(selectedDay);
          setIsInvalid(false);
        } else if (!parseDate(input?.value, format!)) {
          setIsInvalid(true);
        }
      } else {
        onChange(selectedDay);
        setDateInputValue(selectedDay);
        setIsInvalid(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  React.useEffect(() => {
    if (!isEqual(value!, dateInputValue!)) {
      changeHandler(value);
    }
  }, [value, dateInputValue, changeHandler]);

  React.useEffect(() => {
    isError!(isInvalid);
  }, [isInvalid, isError]);

  return (
    <div className={className} style={{ display: 'inline-block', width: width ? width : '132px' }}>
      <div className={isInvalid ? 'date_input_container_error tooltip' : 'date_input_container'}>
        {isInvalid && <span className="tooltiptext">{errorMessage ? errorMessage : ''}</span>}
        <DayPickerInput
          classNames={{
            container: 'DayPickerInput',
            overlayWrapper: 'DayPickerInput-OverlayWrapper',
            overlay: classNames('DayPickerInput-Overlay', {
              [styles.pullRight]: pullRight,
            }),
          }}
          dayPickerProps={{
            months: locale === 'ru' ? MONTHS_RU : MONTHS_EN,
            weekdaysLong: locale === 'ru' ? WEEKDAYS_LONG_RU : WEEKDAYS_LONG_EN,
            weekdaysShort: locale === 'ru' ? WEEKDAYS_SHORT_RU : WEEKDAYS_SHORT_EN,
            firstDayOfWeek: FIRST_DAY_OF_WEEK,
            labels: LABELS,
            // disabledDays: { daysOfWeek: [0] },
            // disabledDays: { after: new Date(2019, 10, 20) },
            disabledDays,
          }}
          placeholder={placeholder ? placeholder : 'DD-MM-YYYY'}
          format={format ? format : 'dd-MM-yyyy'}
          formatDate={formatDate}
          parseDate={parseDate}
          onDayChange={changeHandler}
          value={value}
        />
        <div className={'datePickerIcon'}>
          <DatePickerIcon fill={'#5ab8f1'} />
        </div>
      </div>
    </div>
  );
};

export default DateInput;
